import { Component, Input } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import { MissingFieldSection } from '../../fct/services/validate-fct-data.service';
import { LeapDispatch } from 'src/app/public/leap/state/leap.dispatch';
import { TestHooks } from './missing-fields-notif.hooks';

@Component({
	selector: 'app-missing-fields-notif',
	templateUrl: './missing-fields-notif.component.html',
	animations: [openClose()],
	standalone: false,
})
export class MissingFieldsNotifComponent {
	testHooks = TestHooks;

	public ICON = ICON;
	backUrlParams = { 'back-string': 'Title insurance' };
	public showFields = false;

	@Input() missing: MissingFieldSection[] = [];

	constructor(private leapDispatch: LeapDispatch) {}

	toggleShowFields(): void {
		this.showFields = !this.showFields;
	}
}
